export interface salesDespatchPackSummaryReport {
  packNo: string;
  packType: string;
  dimensions: string;
  volume: number;
  grossKgs: number;
  nettKgs: number;
  tareKgs: number;
  noOfItems: number;
}
